import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import './scss/index.scss';

export default class InquiryIdentity extends React.Component <any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			inquiryInfo: '',
			companyId: this.props.location.state ? this.props.location.state.companyId : '',
		}
	}

	componentDidMount() {
		this.getInquiryStatus();

	}

	render() {
		return (
			<div className="gray-bg page-inquiryIdentity">
				<div 
					className="inquiry-box" 
					onClick={() => this.props.history.push('/inquiry/message?companyId=' + this.state.companyId + '&type=1'
					)}
				>
					<div className="icon-warrper">
						<img src={require('@/assets/images/identity_icon2.png')} alt="" className="icon"/>
						{
							this.state.inquiryInfo.seller > 0 ? <span className="dot"></span> : ''
						}
						
					</div>
					<p className="title">我是卖家</p>
				</div>
				<div 
					className="inquiry-box" 
					onClick={() => this.props.history.push('/inquiry/message?companyId=' + this.state.companyId + '&type=2'
					)}
				>
					<div className="icon-warrper">
						<img src={require('@/assets/images/identity_icon1.png')} alt="" className="icon"/>
						{
							this.state.inquiryInfo.buyer > 0 ? <span className="dot"></span> : ''
						}
					</div>
					<p className="title">我是买家</p>
				</div>
			</div>
		)
	}

	// 查询询盘消息
  	private async getInquiryStatus() {
		const r = await request({
		  method: "get",
		  url: `${config.MALLAPI}api/wshop/ask/user-ask`,
		});

		if (r.error_code === 0) {
		  this.setState({
		  	inquiryInfo: r.data
		  })
		}
  	} 
}